import React, { useState } from 'react'
import Catalog from 'blocks.app/catalog/catalog'
import { ARTS_CATALOG_CONFIG, CatalogizatorSelectedItems } from '../InstancesCatalogCatalogizator-types'

export const InstancesCatalogArts = () => {
    const [selectedItems, setSelectedItems] = useState<CatalogizatorSelectedItems>([])

    return (
        <Catalog
            type={ARTS_CATALOG_CONFIG.type}
            onSelect={setSelectedItems}
            selectedItems={selectedItems}
            treeView={ARTS_CATALOG_CONFIG.treeView}
            additionalData={ARTS_CATALOG_CONFIG.additionalData}
            fixedHeader={ARTS_CATALOG_CONFIG.fixedHeader}
            isExistRightToolbar={ARTS_CATALOG_CONFIG.isExistRightToolbar}
            hideHeader={ARTS_CATALOG_CONFIG.hideHeader}
        />
    )
}
